<template>
    <button
        v-if="!isAdFreeActive && appStore.isPurchaseEnabled"
        :class="$style.button"
        data-interface-target="no-ad-header-button"
        @click="adDisabledStore.openDisabledAdModal('header-no-ad-button')"
    >
        <img
            :class="$style.icon"
            :src="NoAdImg"
            alt="No Ad"
        />
        <Typography
            type="label"
            size="l"
        >
            {{ $tr('header.noAds') }}
        </Typography>
    </button>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'

import Typography from '@/components/Typography.vue'
import { useAdDisabledStore } from '@/store/ad-disabled-store'
import { useAppStore } from '@/store/app-store'

import NoAdImg from './images/no-ad.webp'

const adDisabledStore = useAdDisabledStore()
const { isAdFreeActive } = storeToRefs(adDisabledStore)
const appStore = useAppStore()
</script>

<style module>
.button {
    flex-shrink: 0;
    padding: 4px 16px 4px 4px;
    background: var(--carbon-400);
    border-radius: 1000px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: box-shadow 0.3s;
}

.button:hover,
.button:focus {
    outline: 0.5px solid #2e53b2;
    background: var(--carbon-300);
    box-shadow: 0 0 30px 0 #447d9e inset;
}

.icon {
    width: 48px;
    height: 48px;
}
</style>
